import { FormFieldTypes } from "../../../../../data/formFieldType";

export const eventRegistrationApprovalTasklistFormData = {
    name: "EventListFilterFormData",
    initialState: {
        eventName: '',
    },
    formFields: [
        {
            id: "eventName",
            lable: "Event Name / Contact Person",
            Field_Name: "Event Name / Contact Person",
            fieldType: FormFieldTypes.INPUT,
            dataField: "eventName",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-lg-4 mb-2 p-3 mx-2",
            },
        },
    ],
    formSetting: {
        isViewOnly: false
    }
}